module.exports = __webpack_public_path__ + "static/media/MobileTrade.ff1c12ed.png";